import React from "react";
import ReactLoading from 'react-loading';

const Loading = () => {
    return (
        <div className="loading-g v-align-c">
            <div>
                <ReactLoading type="cylon" color="#000" width={'100%'} />
                <span>Cargando</span>
            </div>
        </div>
    );
};

export default Loading;